"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCircularEconomy = function IconCircularEconomy(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M41.996 17.875A19 19 0 0 0 5.243 20.94l1.974.318.06-.35a17 17 0 0 1 32.715-2.705l-2.412.396L42 24l2.46-6.53zM6 24l-2.46 6.53 2.468-.405a19 19 0 0 0 36.677-2.85l-1.97-.35-.066.352a17 17 0 0 1-32.636 2.518l2.407-.395zm19-3.03-.001 2.643 1.537-1.537.707.707L25 25.028 25 27.97h-1l-.001-1.074-2.802-2.792.706-.708 2.096 2.089L24 20.97zm-1.007-10.055-1.228 1.555-.432.565-.534.718c-.72.98-1.439 2.012-2.111 3.049l-.32.5c-2.043 3.252-3.088 5.758-3.088 7.558a8.24 8.24 0 0 0 3.698 6.974l.262.164 1.06-1.696-.24-.15-.215-.15a6.24 6.24 0 0 1-2.565-5.13c0-1.389 1-3.726 3.002-6.853l.58-.88a66 66 0 0 1 1.55-2.203l.18-.244.421-.565.236.315a71 71 0 0 1 2.468 3.566l.21.332c1.863 2.961 2.793 5.182 2.793 6.51v.224A6.004 6.004 0 0 1 23.96 31l-.96.038v5.96h2l-.001-4.097.28-.049a8 8 0 0 0 6.44-8.025l-.004-.2c-.077-1.833-1.197-4.393-3.313-7.697l-.269-.416c-1.08-1.653-2.466-3.548-2.89-4.047l-.023-.026z",
    clipRule: "evenodd"
  })));
};

export { IconCircularEconomy, IconCircularEconomy as default };
